module.exports = __webpack_public_path__ + "img/middle_21.11d3dcee.png";